module.exports = __webpack_public_path__ + "static/cross-platform.81ff984c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/features/cross-platform.png
// module id = 995
// module chunks = 72138227098318